import { fetcher } from '@commenda/utils';

import type { AdminHubSpotCompanySummary } from './useAdminCompanyExternalConnections';

export interface SearchAdminHubSpotCompaniesParams {
  query: string;
  limit?: number;
}

/** Imperative twin of useSearchAdminHubSpotCompanies, for debounced search. */
export async function searchAdminHubSpotCompanies({
  query,
  limit = 10,
}: SearchAdminHubSpotCompaniesParams): Promise<AdminHubSpotCompanySummary[]> {
  const params = new URLSearchParams({ query, limit: String(limit) });
  const response = await fetcher(
    `admin/external-connections/hubspot/companies/search?${params.toString()}`,
    { method: 'GET' }
  );

  if (!response.ok) throw new Error('Failed to search HubSpot companies');
  return response.json();
}
